
import { Vue, Component } from 'vue-property-decorator';
import TheCreditpushMainHeader from '@/components/creditpushMain/TheCreditpushMainHeader.vue';
import TheCreditpushMainFooter from '@/components/creditpushMain/TheCreditpushMainFooter.vue';

@Component({
  components: { TheCreditpushMainHeader, TheCreditpushMainFooter },
})
export default class CreditpushMainLayout extends Vue {}
